export default "__VITE_ASSET__449b7333__"